






import Vue from 'vue';

export default Vue.extend({
  name: 'Spinner',
  props: {
    light: {
      type: Boolean,
      default: false
    }
  }
});
